import { render, staticRenderFns } from "../sender/sender.html?vue&type=template&id=010755f0&scoped=true&external"
import script from "../sender/sender.js?vue&type=script&lang=js&external"
export * from "../sender/sender.js?vue&type=script&lang=js&external"
import style0 from "../sender/sender.css?vue&type=style&index=0&id=010755f0&prod&scoped=true&lang=css&external"
import style1 from "./Sender.vue?vue&type=style&index=1&id=010755f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010755f0",
  null
  
)

export default component.exports